.filterable-table {
  display: grid;
  grid-template:
    'filter' min-content
    'table' 1fr / 1fr;
  gap: var(--mantine-spacing-sm);
  height: 100%;
  max-height: clamp(20rem, 40cqmin, 40rem);
  overflow: auto;
  anchor-name: --filterable-table;
  anchor-scope: all;
}

.filter-container {
  background: var(--mantine-color-dark-6);
  z-index: 10;
  position: fixed;
  display: flex;
  grid-area: filter;
  gap: var(--mantine-spacing-sm);
  align-items: center;
  position-anchor: --filterable-table;
  left: calc(anchor(left) + var(--mantine-spacing-xs));
  bottom: calc(anchor(bottom) + var(--mantine-spacing-xs));
  font-size: var(--mantine-font-size-xs);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease-out;
  /* FIXME: improve placement later */
  display: none;
  .filterable-table:hover & {
    pointer-events: auto;
    opacity: 1;
  }
}

.filter-count {
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-dimmed);
  white-space: nowrap;
}

.empty-filter-result {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  align-items: center;
  justify-content: center;
  padding: var(--mantine-spacing-xl);
  color: var(--mantine-color-dimmed);
  text-align: center;
}

.table-container {
  display: grid;
  grid-template:
    'header' min-content
    'body' 1fr / 1fr;
  overflow: auto;
}

.table-header {
  display: grid;
  grid-area: header;
  place-content: center;
  padding-block: calc(var(--mantine-spacing-md) * 0.25);
  font-size: var(--mantine-font-size-sm);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
  color: var(--mantine-color-dark-0);
  border-bottom: 1px solid var(--mantine-color-dark-3);
}

.data-table-container {
  --mantine-datatable-border-color-dark: alpha(var(--mantine-color-dark-accent-4), 0.5);
  overflow: hidden;
  font-variation-settings: 'wdth' 95;
  font-variant-numeric: tabular-nums;

  tr {
    th,
    td {
      &:first-child {
        background: alpha(var(--mantine-color-dark-accent-8), 0.4);
      }
    }
  }

  a {
    color: var(--mantine-color-white);
    text-decoration: none;
    border-bottom: 1px dashed var(--mantine-color-dark-3);
  }

  .caption {
    margin-bottom: var(--mantine-spacing-sm);
    font-weight: var(--mantine-heading-font-weight);
  }

  .numeric-value {
    text-align: right;
  }

  .na {
    color: var(--mantine-color-dark-3);
    text-align: center;
  }

  .unit {
    margin-left: calc(var(--mantine-spacing-md) * 0.4);
    font-weight: normal;
    color: var(--mantine-color-dark-1);
  }
}
